/**
 * Administracion de usuarios municipales (informadores municipales)
 */

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_USUARIOS_INFORMADORES = "obtenerUsuariosInformadores";
export const OBTENER_USUARIOS_INFORMADORES_MUNI = "obtenerUsuariosInformadoresMuni";
export const OBTENER_USUARIO_INFORMADOR = "obtenerUsuarioInformador";
export const REGISTRAR_USUARIO_INFORMADOR = "registrarUsuarioInformador";
export const ACTUALIZAR_USUARIO_INFORMADOR = "actualizarUsuarioInformador";
export const ASIGNAR_USUARIO_INFORMADOR = "asignarInformadorMunicipal";
export const ACTUALIZAR_ASIGNACION_USUARIO_INFORMADOR = "actualizarAsignacionInformadorMunicipal";
export const OBTENER_ASIGNACION_USUARIO_INFORMADOR_MUNI = "obtenerAsignacionUsuarioInformadorMunicipal";
// mutation types
export const SET_USUARIOS_INFORMADORES = "setUsuariosInformadores";
export const SET_USUARIO_INFORMADOR = "setUsuarioInformador";
export const SET_ASIGNACION_USUARIO_INFORMADOR = "setAsignacionUsuarioInformador";

const state = {
    usuariosInformadores: [],
    usuarioInformador:[],
    asignacionInformador:[],
}

const getters = {
    obtenerusuariosInformadores(state) {
      return state.usuariosInformadores;
    },
}

const actions = {
    async [OBTENER_USUARIOS_INFORMADORES](context, departamentoId) {

       
        /*
        * Si el estado es null va a traer a todas los usuariosInformadores, de lo contrario va a traer los usuariosInformadores por estado
        *
        */
        let endpoint = `api/Usuarios/Rol/${4}`
        if(departamentoId>0){
            endpoint = `api/Usuarios/Informador/${departamentoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_USUARIOS_INFORMADORES, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });     
    },

    /**
     * Obtener los informadores municipales por municipio y año de medición
     * @param {*} context 
     * @param {*} municipioId 
     * @returns 
     */

    async [OBTENER_USUARIOS_INFORMADORES_MUNI](context, datos) {
        console.log(datos)
       
        /*
        * Si el estado es null va a traer a todas los usuariosInformadores, de lo contrario va a traer los usuariosInformadores por estado
        *
        */
        let endpoint = `api/AsignarInformador/Municipio/${datos.municipiosId}/${datos.periodoMedicionId}`
       /* if(estadoId){
            endpoint = `api/usuarioInformador/Estado/${estadoId}`
        }*/

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_USUARIOS_INFORMADORES, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });     
    },


    async [OBTENER_USUARIO_INFORMADOR](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Usuarios/`)
                .then(({ data }) => {
                    context.commit(SET_USUARIO_INFORMADOR, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    /**
     * Obtener los datos de la asignacion de un usuario informador a una municipalidad.
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    async [OBTENER_ASIGNACION_USUARIO_INFORMADOR_MUNI](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/AsignarInformador/`)
                .then(({ data }) => {
                    context.commit(SET_ASIGNACION_USUARIO_INFORMADOR, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

   

    async [REGISTRAR_USUARIO_INFORMADOR](context, datosUsuario){
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Usuarios`, datosUsuario)
                .then(({ data }) => {
                    context.commit(SET_USUARIO_INFORMADOR, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    async [ACTUALIZAR_USUARIO_INFORMADOR](context, datosUsuario){
        let id = datosUsuario.id;
       
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Usuarios/`, datosUsuario)
                .then(({ data }) => {
                    context.commit(SET_USUARIO_INFORMADOR, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },


    /**
     * Asignar Informador Municipal a un periodo y municipalidad
     * @param {*} context 
     * @param {*} datosUsuario 
     * @returns 
     */

    async [ASIGNAR_USUARIO_INFORMADOR](context, datosUsuario){
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/AsignarInformador`, datosUsuario)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_INFORMADOR, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },

    /**
     * Actualizar la información de la asignación.
     * @param {*} context 
     * @param {*} datosUsuario 
     * @returns 
     */

    async [ACTUALIZAR_ASIGNACION_USUARIO_INFORMADOR](context, datosUsuario){
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${datosUsuario.id}?endpoint=api/AsignarInformador/`, datosUsuario)
                .then(({ data }) => {
                    if(data.status==200){
                        context.commit(SET_USUARIO_INFORMADOR, data.data);
                    }
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    

}

const mutations = {
    [SET_USUARIOS_INFORMADORES](state, data) {
        state.usuariosInformadores = data;
    },

    [SET_USUARIO_INFORMADOR](state, data) {
        state.usuarioInformador = data;
    },
    
    [SET_ASIGNACION_USUARIO_INFORMADOR](state, data) {
        state.asignacionInformador = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}